




























import { Component, Vue } from 'vue-property-decorator'
import { getLotteryRecords } from '@/api/lottery'

@Component({ name: 'LotteryRecord' })
export default class extends Vue {
  private tableData: any[] = []
  private userId = ''
  private page = 1
  private pageSize = 10
  private counts = 0

  created() { this.loadList() }

  typeText(type: number) {
    return ['谢谢参与', '余额', '满减券', '免费菜'][type] || '未知'
  }

  async loadList() {
    const res: any = await getLotteryRecords({
      page: this.page,
      pageSize: this.pageSize,
      userId: this.userId || undefined
    })
    if (String(res.data.code) === '1') {
      this.tableData = res.data.data.records
      this.counts = res.data.data.total
    }
  }

  handlePageChange(p: number) {
    this.page = p
    this.loadList()
  }
}
